import type { IIncomeBusinessTaxYear } from './IncomeBusinessTaxYear.interface';

export default class IncomeBusinessTaxYear implements IIncomeBusinessTaxYear {
  taxYear: number;
  grossSales: number;
  grossSalesComments: string;
  profitBeforeTax: number;
  profitBeforeTaxComments: string;
  depreciation: number;
  depreciationComments: string;
  interestAndOtherAddbacks: number;
  interestAndOtherAddbacksComments: string;
  leaseRentals: number;
  leaseRentalsComments: string;
  amortisation: number;
  amortisationComments: string;
  lossOnSaleOfFixedAsset: number;
  lossOnSaleOfFixedAssetComments: string;
  profitOnSaleOfFixedAsset: number;
  profitOnSaleOfFixedAssetComments: string;
  nonRecurringExpense: number;
  nonRecurringExpenseComments: string;
  taxPaid: number;
  taxPaidComments: string;

  static build = (data: IIncomeBusinessTaxYear) => new IncomeBusinessTaxYear(data);
  static blank = () => new IncomeBusinessTaxYear();

  /**
   * Constructor
   * @param {IIncomeBusinessTaxYear} data
   */
  constructor(data?: IIncomeBusinessTaxYear) {
    this.taxYear = parseInt(data?.taxYear || 0, 10);
    this.grossSales = parseFloat(data?.grossSales || 0);
    this.grossSalesComments = data?.grossSalesComments || '';
    this.profitBeforeTax = parseFloat(data?.profitBeforeTax || 0);
    this.profitBeforeTaxComments = data?.profitBeforeTaxComments || '';
    this.depreciation = parseFloat(data?.depreciation || 0);
    this.depreciationComments = data?.depreciationComments || '';
    this.interestAndOtherAddbacks = parseFloat(data?.interestAndOtherAddbacks || 0, 10);
    this.interestAndOtherAddbacksComments = data?.interestAndOtherAddbacksComments || '';
    this.leaseRentals = parseFloat(data?.leaseRentals || 0);
    this.leaseRentalsComments = data?.leaseRentalsComments || '';
    this.amortisation = parseFloat(data?.amortisation || 0);
    this.amortisationComments = data?.amortisationComments || '';
    this.lossOnSaleOfFixedAsset = parseFloat(data?.lossOnSaleOfFixedAsset || 0);
    this.lossOnSaleOfFixedAssetComments = data?.lossOnSaleOfFixedAssetComments || '';
    this.profitOnSaleOfFixedAsset = parseFloat(data?.profitOnSaleOfFixedAsset || 0, 10);
    this.profitOnSaleOfFixedAssetComments = data?.profitOnSaleOfFixedAssetComments || '';
    this.nonRecurringExpense = parseFloat(data?.nonRecurringExpense || 0);
    this.nonRecurringExpenseComments = data?.nonRecurringExpenseComments || '';
    this.taxPaid = parseFloat(data?.taxPaid || 0);
    this.taxPaidComments = data?.taxPaidComments || '';
  }
}
